<template>
  <div class="mx-4 w-[calc(100%-2rem)]">
    <div class="px-3 py-2 pt-3">
      <h4 class="font-medium">{{ $t("products.paymentMethod") }}</h4>
    </div>

    <van-form class="">
      <!-- 付款方式选择 -->
      <div class="mb-2 rounded-lg bg-white">
        <van-radio-group v-model="selectedMethod" class="bg-transparent">
          <van-cell-group class="bg-transparent">
            <van-cell
              class="bg-transparent"
              v-for="method in paymentMethods"
              :key="method.value"
              :title="$t(method.label)"
              clickable
              @click="handleMethod(method)">
              <template #title>
                <div class="flex items-center text-sm text-gray-700">
                  <span>{{ $t(method.label) }}</span>
                </div>
              </template>
              <template #right-icon>
                <van-radio :name="method.value" checked-color="#ff7a00" />
              </template>
            </van-cell>
          </van-cell-group>
        </van-radio-group>
      </div>

      <!-- 支付渠道 -->
      <div class="rounded-lg bg-white pt-1 pb-2" v-if="selectedMethod === 'onlineBanking' || selectedMethod === 'eWallet'">
        <div class="text-md px-3 py-2 text-gray-700">{{ $t(selectedMethodText) }}</div>

        <div class="h-50 overflow-y-auto">
          <van-radio-group v-if="selectedMethod === 'onlineBanking'" v-model="channel" class="bg-transparent">
            <van-cell-group class="bg-transparent">
              <van-cell
                class="bg-transparent"
                v-for="method in onlineBank"
                :key="method.value"
                :title="method.label"
                clickable
                @click="channel = method.value">
                <template #title>
                  <div class="flex items-center text-sm text-gray-700">
                    <img class="w-4 h-4 mr-2" :src="method.icon" alt="" />
                    <span>{{ method.label }}</span>
                  </div>
                </template>
                <template #right-icon>
                  <van-radio :name="method.value" checked-color="#ff7a00" />
                </template>
              </van-cell>
            </van-cell-group>
          </van-radio-group>

          <van-radio-group v-if="selectedMethod === 'eWallet'" v-model="channel" class="bg-transparent">
            <van-cell-group class="bg-transparent">
              <van-cell
                class="bg-transparent"
                v-for="method in eWallet"
                :key="method.value"
                :title="method.label"
                clickable
                @click="channel = method.value">
                <template #title>
                  <div class="flex items-center text-sm text-gray-700">
                    <img class="w-4 h-4 mr-2" :src="method.icon" alt="" />
                    <span>{{ method.label }}</span>
                  </div>
                </template>
                <template #right-icon>
                  <van-radio :name="method.value" checked-color="#ff7a00" />
                </template>
              </van-cell>
            </van-cell-group>
          </van-radio-group>
        </div>
      </div>
    </van-form>

    <van-popup v-model="showDatePicker" position="bottom">
      <van-datetime-picker
        v-model="selectedDate"
        type="year-month"
        :max-date="maxDate"
        @confirm="onDateConfirm"
        @cancel="showDatePicker = false" />
    </van-popup>
  </div>
</template>

<script>
import { Form, Checkbox, RadioGroup, CellGroup, Radio, Popup, DatetimePicker } from "vant"
import dayjs from "dayjs"
export default {
  name: "PaymentMethod",
  components: {
    [Form.name]: Form,
    [Checkbox.name]: Checkbox,
    [RadioGroup.name]: RadioGroup,
    [CellGroup.name]: CellGroup,
    [Radio.name]: Radio,
    [Popup.name]: Popup,
    [DatetimePicker.name]: DatetimePicker,
  },
  data() {
    return {
      selectedMethod: "creditCard",
      selectedMethodText: "products.creditCard",
      channel: "creditAN",
      paymentMethods: [
        { value: "creditCard", label: "products.creditCard" },
        { value: "onlineBanking", label: "products.onlineBanking" },
        { value: "eWallet", label: "products.eWallet" },
      ],
      form: {},
      showDatePicker: false,
      selectedDate: new Date(),
      maxDate: dayjs().add(20, "year").toDate(),
      onlineBank: [
        { value: "fpx_abb", label: "Affin Bank", icon: require("@/assets/images/online-new/Affin Bank.png") },
        // { value: "FPX_AGROBANK", label: "Agrobank Online", icon: require("@/assets/images/online-new/Agrobank Online.png") },
        { value: "fpx_abmb", label: "Alliance Bank", icon: require("@/assets/images/online-new/Alliance Bank.png") },
        { value: "fpx_amb", label: "Am Bank", icon: require("@/assets/images/online-new/Am Bank.png") },
        { value: "fpx_bimb", label: "Bank Islam", icon: require("@/assets/images/online-new/Bank Islam.png") },
        { value: "fpx_bmmb", label: "Bank Muamalat", icon: require("@/assets/images/online-new/Bank Muamalat.png") },
        { value: "fpx_bkrm", label: "Bank Rakyat", icon: require("@/assets/images/online-new/Bank Rakyat.png") },
        { value: "fpx_bsn", label: "Bank Simpanan Nasional", icon: require("@/assets/images/online-new/Bank Simpanan Nasional.png") },
        { value: "fpx_cimbclicks", label: "CIMB Bank", icon: require("@/assets/images/online-new/CIMB Bank.png") },
        { value: "fpx_hlb", label: "HLB Connect", icon: require("@/assets/images/online-new/HLB Connect.png") },
        { value: "fpx_hsbc", label: "HSBC Online", icon: require("@/assets/images/online-new/HSBC Online.png") },
        { value: "fpx_kfh", label: "Kuwait Finance House", icon: require("@/assets/images/online-new/Kuwait Finance House.png") },
        { value: "fpx_mb2u", label: "Maybank2u", icon: require("@/assets/images/online-new/Maybank2u.png") },
        { value: "fpx_ocbc", label: "OCBC Bank", icon: require("@/assets/images/online-new/OCBC Bank.png") },
        { value: "fpx_pbb", label: "PBB Online", icon: require("@/assets/images/online-new/PBB Online.png") },
        { value: "fpx_rhb", label: "RHB Bank", icon: require("@/assets/images/online-new/RHB Bank.png") },
        { value: "fpx_scb", label: "Standard Chartered Bank", icon: require("@/assets/images/online-new/Standard Chartered Bank.png") },
        { value: "fpx_uob", label: "UOB Online", icon: require("@/assets/images/online-new/UOB Online.png") },

        
        // { value: "PNCO_ABB", label: "Affin Bank", icon: require("@/assets/images/online-new/Affin Bank.png") },
        // { value: "PNCO_AGROBANK", label: "Agrobank Online", icon: require("@/assets/images/online-new/Agrobank Online.png") },
        // { value: "PNCO_ABMB", label: "Alliance Bank", icon: require("@/assets/images/online-new/Alliance Bank.png") },
        // { value: "PNCO_AMB", label: "Am Bank", icon: require("@/assets/images/online-new/Am Bank.png") },
        // { value: "PNCO_BIMB", label: "Bank Islam", icon: require("@/assets/images/online-new/Bank Islam.png") },
        // { value: "PNCO_BMMB", label: "Bank Muamalat", icon: require("@/assets/images/online-new/Bank Muamalat.png") },
        // { value: "PNCO_BKRM", label: "Bank Rakyat", icon: require("@/assets/images/online-new/Bank Rakyat.png") },
        // { value: "PNCO_BSN", label: "Bank Simpanan Nasional", icon: require("@/assets/images/online-new/Bank Simpanan Nasional.png") },
        // { value: "PNCO_CIMBCLICKS", label: "CIMB Bank", icon: require("@/assets/images/online-new/CIMB Bank.png") },
        // { value: "PNCO_HLB", label: "HLB Connect", icon: require("@/assets/images/online-new/HLB Connect.png") },
        // { value: "PNCO_HSBC", label: "HSBC Online", icon: require("@/assets/images/online-new/HSBC Online.png") },
        // { value: "PNCO_KFH", label: "Kuwait Finance House", icon: require("@/assets/images/online-new/Kuwait Finance House.png") },
        // { value: "PNCO_MB2U", label: "Maybank2u", icon: require("@/assets/images/online-new/Maybank2u.png") },
        // { value: "PNCO_OCBC", label: "OCBC Bank", icon: require("@/assets/images/online-new/OCBC Bank.png") },
        // { value: "PNCO_PBB", label: "PBB Online", icon: require("@/assets/images/online-new/PBB Online.png") },
        // { value: "PNCO_RHB", label: "RHB Bank", icon: require("@/assets/images/online-new/RHB Bank.png") },
        // { value: "PNCO_SCB", label: "Standard Chartered Bank", icon: require("@/assets/images/online-new/Standard Chartered Bank.png") },
        // { value: "PNCO_UOB", label: "UOB Online", icon: require("@/assets/images/online-new/UOB Online.png") },


        // { value: "PNCO_BOCM", label: "Bank Of China", icon: require("@/assets/images/online-new/.png")},
        // { value: "PNCO_MBSB", label: "MBSB Bank" , icon: require("@/assets/images/online-new/.png")},
        // { value: "fpx", label: "MyClear FPX B2C" , icon: require("@/assets/images/online-new/.png")},
        // { value: "FPX_AGROBANK", label: "FPX AGROBANK" , icon: require("@/assets/images/online-new/.png")},
        // { value: "RPP_DuitNowQR", label: "DuitNow QR", icon: require("@/assets/images/online-new/.png") },
      ],
      eWallet: [
        { value: "TNG-EWALLET", label: "TnG eWallet", icon: require("@/assets/images/touch/TnG eWallet.png") },
        { value: "GrabPay", label: "GrabPay", icon: require("@/assets/images/touch/GrabPay.png") },
        { value: "ShopeePay", label: "ShopeePay", icon: require("@/assets/images/touch/ShopeePay.png") },
        { value: "BOOST", label: "Boost Wallet", icon: require("@/assets/images/touch/Boost Wallet.png") },
        { value: "alipay", label: "Alipay", icon: require("@/assets/images/touch/Alipay.png") },
        { value: "WeChatPay", label: "WeChat Pay", icon: require("@/assets/images/touch/WeChat Pay.png") },
        // { value: "RPP_DuitNowQR", label: "DuitNow QR" },
      ],
      creditCard: [{ value: "creditAN", label: "Credit Card/ Debit Card" }],
    }
  },
  props: {
    bankInfo: {
      type: Object,
      default: () => ({}),
    },
  },
  watch: {
    bankInfo: {
      handler(newVal) {
        // console.log("addressData :>> ", newVal)
        this.form = newVal
      },
      deep: true,
    },
  },
  methods: {
    handleMethod(method) {
      console.log('method :>> ', method);
      // if (method.value === this.selectedMethod) {
      //   return
      // }
      console.log('method--1 :>> ', method);
      this.selectedMethod = method.value
      this.selectedMethodText = method.label

      if (method.value === "creditCard") {
        this.channel = "creditAN"
      } else if (method.value === "onlineBanking") {
        this.channel = "fpx_abb"
      } else if (method.value === "eWallet") {
        this.channel = "TNG-EWALLET"
      } else {
        this.channel = ""
      }
    },
    onBankChange(value) {
      this.onlineBank = value
      this.$emit("channel-change", {
        channel: value,
      })
    },
    selectPaymentMethod(method) {
      this.selectedMethod = method
      this.$emit("payment-method-change", {
        method: method,
        form: method === "creditCard" ? this.form : null,
      })
    },
    getPaymentData() {
      return {
        method: this.selectedMethod,
        form: this.form,
        channel: this.channel,
      }
    },
    validatePayment() {
      const { channel } = this
      return channel
    },
    // 日期确认
    onDateConfirm(value) {
      const year = value.getFullYear()
      const month = String(value.getMonth() + 1).padStart(2, "0")
      this.form.expireDate = `${year}-${month}`
      this.showDatePicker = false
    },
  },
  watch: {
    channel(newVal) {
      console.log('newVal :>> ', newVal);
    },
  },
  mounted() {
    // 初始化时发送默认选择
    this.selectPaymentMethod(this.selectedMethod)
  },
}
</script>

<style scoped>
/deep/.van-cell {
  background-color: transparent;
}
</style>
